import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import TableComponentForReport from './TableComponentForReports';
import {
  GetDateInMMDDYYYYFormat,
  getValueInCurrency,
} from '../../../../common/utils';
import ValueOrNoDataLabel from '../../../../components/common/ValueOrNoDataLabel';
import { getCurrencyFromSetup } from '../../../../common/EntitiesManagement';

export default function ReportPaymentToTechnician({ paymentsToTechnician }) {
  return (
    <div>
      <ReportSectionTitle title={localize.payment_to_technician} />
      <div className="report_section_without_top_border">
        {paymentsToTechnician?.length > 0 ? (
          <TableComponentForReport
            headers={[
              localize.payment_date,
              localize.payment_type,
              localize.value,
              localize.reported_by,
              localize.observations,
            ]}
            rows={paymentsToTechnician.map((payment) => [
              <p className="textAlignedCenter">
                {GetDateInMMDDYYYYFormat(new Date(payment.PaymentDate))}
              </p>,
              <ValueOrNoDataLabel
                data={payment.PaymentTypeData?.Name}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={getValueInCurrency(getCurrencyFromSetup(), payment.Value)}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={payment.CreatedBy}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={payment.Observation}
                hideBackground
                centerValue
              />,
            ])}
          />
        ) : (
          <label className="report_little_text">{localize.no_data}</label>
        )}
      </div>
    </div>
  );
}
